import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
let uid = 0;
/**
 * Sample usage:
 *
 *     <expandable2 expandableTitle="Title">
 *         Lorem ipsum dolor
 *     </expandable2>
 */
@Component({
    selector: 'checkout-expandable',
    templateUrl: './checkout-expandable.html',
    styleUrls: ['./checkout-expandable.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ZippyModule, TranslationModule]
})
export class CheckoutExpandableComponent {
    /**
     * Title
     */
    @Input()
    showCopy = 'Change';
    /**
     * When off only content is shown without expandable
     */
    @Input()
    expandableOff = false;
    /**
     * The content is expanded by default at the beginning
     */
    @Input()
    expandContentByDefault?: boolean;
    /**
     * Zippy id
     */
    @Input()
    expandableId?: string | (string | number)[];
    /**
     * Default zippy id
     */
    readonly defaultId = `checkoutExpandable.${uid++}`;
    get zippyId() {
        return this.expandableId || this.defaultId;
    }
}
